// ADR-0144 §2 — importador de unidades de postventa por planilla.
//
// Dos pasos sobre el mismo archivo:
//   POST /assets/import/dry-run (multipart) → resumen sin escribir nada.
//   POST /assets/import/commit  (multipart) → re-lee, re-valida y aplica
//                                             todo en una transacción.
//   GET  /assets/import/template            → la planilla vacía (.xlsx).
//
// El commit vuelve a recibir el archivo en vez de un id de borrador: así
// no hay tabla de borradores, y lo que se aplica es exactamente lo que
// el servidor valida en ese momento contra la base. Si hay un solo error
// el commit responde 422 con este mismo resumen y no escribe nada.
import { z } from "zod";
export const UNIT_IMPORT_ACTIONS = ["create", "update", "unchanged"];
/** Un problema de una fila (o de la hoja entera cuando `row` es null). El
 *  `message` va en es-CL, listo para pintar. */
export const unitImportIssueSchema = z.object({
    sheet: z.string(),
    row: z.number().int().positive().nullable(),
    message: z.string(),
});
/** Lo que el importador hará (o hizo) con cada fila válida de «Unidades». */
export const unitImportRowSchema = z.object({
    row: z.number().int().positive(),
    project: z.string(),
    unit: z.string(),
    action: z.enum(UNIT_IMPORT_ACTIONS),
});
export const unitImportSummarySchema = z.object({
    /** `dry_run`: nada se escribió. `commit`: todo se escribió. */
    mode: z.enum(["dry_run", "commit"]),
    toCreate: z.number().int().nonnegative(),
    toUpdate: z.number().int().nonnegative(),
    unchanged: z.number().int().nonnegative(),
    /** Proyectos cuyos contactos de emergencia se reemplazan. */
    emergencyProjects: z.array(z.string()),
    rows: z.array(unitImportRowSchema),
    errors: z.array(unitImportIssueSchema),
    warnings: z.array(unitImportIssueSchema),
});
//# sourceMappingURL=unit-import.js.map